if (!window.customElements.get('instant-search')) {
  class InstantSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.targetItems = document.querySelectorAll(this.getAttribute('data-target-items'));
    }

    connectedCallback() {
      this.input.addEventListener('keyup', () => this.searchItems());
    }

    searchItems() {
      // Accounting for dynamically created elements
      if (!this.targetItems.length) {
        this.targetItems = document.querySelectorAll(this.getAttribute('data-target-items'));
      }

      if (this.input.value != '') {
        this.targetItems.forEach((item) => {
          const searchAttribute = item.getAttribute('data-search-attribute').toLowerCase();
          item.classList.toggle('hidden', searchAttribute.indexOf(this.input.value.toLowerCase()) === -1);
        });
      } else {
        this.targetItems.forEach((item) => item.classList.remove('hidden'));
      }
    }
  }

  window.customElements.define('instant-search', InstantSearch);
}

if (!window.customElements.get('client-information')) {
  class ClientInformation extends HTMLElement {
    constructor() {
      super()
      this.userSelected = false;
      this.select = this.querySelector('[data-client-information-name]')
      this.emailInput = this.querySelector('[data-client-information-email]')
      this.nameProperty = document.querySelector('input[name="properties[Client Name]"]')
      this.emailProperty = document.querySelector('input[name="properties[Email Address]"]')

      // custom search dropdown start
      this.selectTrigger = this.querySelector("[data-trigger]");
      this.selectDropdown = this.querySelector("[data-dropdown]");
      this.selectDropdownOptions = this.querySelectorAll(".select-option");
      this.selectSearch = this.querySelector("[data-search]");
      // custom search dropdown end
    }

    connectedCallback() {
      this.select.addEventListener('change', () => this.updateInputs())
      document.addEventListener('change', () => this.validateSelection())

      // custom search dropdown start
      this.selectTrigger.addEventListener("click",()=>this.toggleSelectDropdown());

      this.selectDropdownOptions.forEach((option) => {
        option.addEventListener("click",()=>this.changeSelectBox(option));
      });

      this.selectSearch.addEventListener('keyup', () => this.searchItems());
      // custom search dropdown end
    }

    validateSelection() {
      const submitButton = document.querySelector('[data-pdp-submit]')
      if (this.userSelected === false) { return; }
      submitButton.removeAttribute('disabled');
    }

    updateInputs() {
      const submitButton = document.querySelector('[data-pdp-submit]')
      const emailAddress = this.select.options[this.select.selectedIndex].getAttribute('data-email-address')
      this.emailInput.value = emailAddress
      this.emailProperty.value = emailAddress
      this.nameProperty.value = this.select.options[this.select.selectedIndex].value
      this.userSelected = true;
      submitButton.removeAttribute('disabled');
    }

    // custom search dropdown start

    toggleSelectDropdown(){
      const isShow = this.selectDropdown.classList.toggle("hidden");
      (!isShow)?this.selectSearch.focus():"";
    }

    changeSelectBox(option){
      this.removeSelected();
      const submitButton = document.querySelector('[data-pdp-submit]');
      const updateAttribute = document.querySelector("#client-name-search");
      const value = option.getAttribute("data-value");
      const emailAddress = option.getAttribute('data-email-address');
      const label = option.innerHTML;
      option.classList.add("selected");
      this.selectTrigger.innerHTML = label;
      // document.querySelector("[data-configurator-client-name]").value = value;
      // document.querySelector("[data-configurator-client-name]").dispatchEvent(new Event('change'));
      this.emailInput.value = emailAddress
      this.emailProperty.value = emailAddress
      this.nameProperty.value = value
      this.userSelected = true;
      updateAttribute.value = value;
      submitButton.removeAttribute('disabled');
      this.toggleSelectDropdown();

    }

    removeSelected(){
      this.selectDropdownOptions.forEach((option) => {
        option.classList.remove("selected");
      });
    }

    searchItems() {
      // Accounting for dynamically created elements
      if (!this.selectDropdownOptions.length) {
        this.selectDropdownOptions = this.querySelectorAll(".select-option");;
      }

      if (this.selectSearch.value != '') {
        this.selectDropdownOptions.forEach((item) => {
          const searchAttribute = item.getAttribute('data-search-value').toLowerCase();
          item.classList.toggle('hidden', searchAttribute.indexOf(this.selectSearch.value.toLowerCase()) === -1);
        });
      } else {
        this.selectDropdownOptions.forEach((item) => item.classList.remove('hidden'));
      }
    }
    // custom search dropdown end

  }

  window.customElements.define('client-information', ClientInformation);
}

if (!window.customElements.get('save-protocol-popup')) {
  class SaveProtocolPopup extends HTMLElement {
    constructor() {
      super()

      this.state = {
        new: false,
        type: null,
        price: null,
        products: [],
        listName: null,
        labelName: null,
        clientName: null,
        emailAddress: null,
        allergyInformation: null
      };

      this.clientSelect = document.querySelector('client-information [data-client-information-name]')
      this.emailAddress = document.querySelector('client-information [data-client-information-email]')
      this.protocolsList = this.querySelector('[data-save-protocol-popup-list]')
      this.newProtocol = this.querySelector('[data-save-protocol-popup-new]')
      this.newProtocolInput = this.querySelector('[data-save-protocol-popup-new-input]')
      this.newProtocolTrigger = this.querySelector('[data-save-protocol-popup-new-trigger]')
      this.saveTrigger = this.querySelector('[data-save-protocol-popup-submit]')
      this.backTrigger = this.querySelector('[data-save-protocol-popup-back-trigger]')
      this.popupHeading = this.querySelector('[data-save-protocol-popup-heading]')
      this.loading = this.querySelector('[data-save-protocol-popup-loading]')
      this.popupForm = this.querySelector('[data-save-protocol-popup-form]')
      this.popupSuccess = this.querySelector('[data-save-protocol-popup-success]')
    }

    connectedCallback() {
      this.wishlistPlusInit()
      this.saveTrigger.addEventListener('click', () => this.saveProtocol())
      this.newProtocolTrigger.addEventListener('click', () => {
        this.state.new = true
        this.updateListDisplay()
      })
      this.backTrigger.addEventListener('click', () => {
        this.state.new = false
        this.updateListDisplay()
      })
    }

    wishlistPlusInit() {
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }

      window.SwymCallbacks.push(onSwymLoadCallback.bind(this));

      /**
       * Wishlist Plus Callbacks
       */
      function onSwymLoadCallback(swat) {
        if (swat) {
          document.addEventListener('saveConfigurator', (event) => createList(swat, event.detail.listName, event.detail.labelName, event.detail.clientName, event.detail.allergyInformation, event.detail.emailAddress, event.detail.products));
          document.addEventListener('change', (event) => {
            this.selectList(event)
            this.updateList(event, swat)
          })
          swat.fetchLists({
            callbackFn: this.buildLists.bind(this),
          })
        } else {
          window.location.reload();
        }
      }

      /**
       * Create Wishlist Plus list
       * @param {Function} swat - Automatically generated Wishlist Plus wrapper function
       * @param {String} listName - Name for the list
       * @param {String} labelName - Name for the label
       * @param {String} clientName - Client name, will get added as an lprop on the list
       * @param {String} allergyInformation - Allergy information, will get added as an lprop on the list
       * @param {String} emailAddress - Email address, will get added as an lprop on the list
       * @param {Array} products - List of products to add to list
       */
      function createList(swat, listName, labelName, clientName, allergyInformation, emailAddress, products) {
        const listConfig = {
          lname: listName,
          lprops: {
            'Label Name': labelName ? labelName : '',
            'Client Name': clientName ? clientName : '',
            'Allergy Information': allergyInformation ? allergyInformation : '',
            'Email Address': emailAddress ? emailAddress : ''
          }
        }

        const fetchListsOnSuccess = function(lists) {
          const matchingList = lists.find((list) => list.lname === listName);

          if (matchingList) {
            swat.deleteList(matchingList.lid, deleteListOnSuccess, deleteListOnError);
          } else {
            swat.createList(listConfig, createListOnSuccess, createListOnError);
          }
        }

        const fetchListsOnError = function(error) {
          console.log('Error while fetching all Lists', error);
        }

        const createListOnSuccess = function(newList) {
          addProductsToList(swat, newList.lid, products);
        }

        const createListOnError = function(error) {
          console.log('Error while creating a List', error);
        }

        const deleteListOnSuccess = function(deletedList) {
          swat.createList(listConfig, createListOnSuccess, createListOnError);
        }

        const deleteListOnError = function(error) {
          console.log('Error while deleting a List', error);
        }

        swat.fetchLists({
          callbackFn: fetchListsOnSuccess,
          errorFn: fetchListsOnError
        });
      }

      /**
       * Add products to Wishlist Plus list
       * @param {Function} swat - Automatically generated Wishlist Plus wrapper function
       * @param {String} lid - List ID that the products should be added to
       * @param {Array} products - List of products to add to the list
       */
      function addProductsToList(swat, lid, products) {
        const onSuccess = function () {
          const savePopupHeading = document.querySelector('[data-save-protocol-popup-heading]');
          const savePopupLoading = document.querySelector('[data-save-protocol-popup-loading]');
          const savePopupSuccess = document.querySelector('[data-save-protocol-popup-success]')

          savePopupHeading.classList.remove('hidden');
          savePopupLoading.classList.add('hidden');
          savePopupSuccess.classList.remove('hidden');
        }

        const onError = function (error) {
          console.log('Error while adding products to the list', error);
        }

        swat.addProductsToList(lid, products, onSuccess, onError);
      }
    }

    buildLists(lists) {
      this.protocolsList.innerHTML = null
      if (lists.length) {
        let listsArray = lists

        if (this.emailAddress !== null) {
          listsArray = lists.filter((list) => list.lprops?.['Email Address'] === this.emailAddress.value)
        }

        listsArray.forEach((list) => {
          const listItem = document.createElement('li')

          listItem.classList.add('save-protocol-popup-list-item')
          listItem.setAttribute('data-search-item', '')
          listItem.setAttribute('data-search-attribute', `${list.lname} ${list.hasOwnProperty('lprops') ? list.lprops["Client Name"] : ''}` )

          listItem.innerHTML = `
            <label class="save-protocol-popup-list-item__button" for="protocol-${list.lid}">
                <input class="sr-only" type="radio" id="protocol-${list.lid}" name="Client Protocol" value="${list.lid}"
                data-lid="${list.lid}"
                data-list-name="${list.lname}"
                data-list-contents='${JSON.stringify(list.listcontents.map(({ du, empi, epi, qty, cprops }) => ({
                  du,
                  empi,
                  epi,
                  qty,
                  cprops,
                })))}'
                ${list.hasOwnProperty('lprops') ?
                  `data-list-client="${list.lprops["Client Name"]}" data-list-allergy="${list.lprops["Allergy Information"]}" data-list-email="${list.lprops["Email Address"]}" data-list-lable="${list.lprops["Label Name"]}"`
                  : ''
                }
                data-save-protocol-popup-list-item>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.95 10L8.65 12.7L14.05 7.3M19 10C19 14.9705 14.9705 19 10 19C5.02943 19 1 14.9705 1 10C1 5.02943 5.02943 1 10 1C14.9705 1 19 5.02943 19 10Z" stroke="black" stroke-width="2"></path>
                </svg>
                <span class="save-protocol-popup-list-item__unselected"></span>
                <div class="save-protocol-popup-list-item__content">
                  <strong>${list.lname}</strong>
                  ${list.hasOwnProperty('lprops') ?
                    `<span>${list.lprops["Client Name"]}</span>`
                    : ''
                  }
                </div>
            </label>
          `

          this.protocolsList.appendChild(listItem)
        })
      }
    }

    updateListDisplay() {
      this.protocolsList.classList.toggle('hidden', this.state.new)
      this.newProtocolTrigger.classList.toggle('hidden', this.state.new)
      this.newProtocol.classList.toggle('hidden', !this.state.new)
      this.backTrigger.classList.toggle('hidden', !this.state.new)

      this.state.listName = null
      this.state.labelName = null
      this.state.allergyInformation = null
      this.state.products = []
    }

    selectList(event) {
      if (!event.target.hasAttribute('data-save-protocol-popup-list-item')) { return }

      this.state.listName = event.target.getAttribute('data-list-name')
      this.state.labelName = event.target.getAttribute('data-list-label')
      this.state.allergyInformation = event.target.getAttribute('data-list-allergy')
      this.state.emailAddress = event.target.getAttribute('data-list-email')
      this.state.clientName = event.target.getAttribute('data-list-client')
      this.state.products = JSON.parse(event.target.getAttribute('data-list-contents'))
    }

    updateList(event, swat) {
      if (!event.target.hasAttribute('data-client-information-name')) { return }

      swat.fetchLists({
        callbackFn: this.buildLists.bind(this),
      })
    }

     /**
     * Pass formatted data from this.state to Wishlist Plus to create and save a new list
     */
     saveProtocol() {
      this.state.listName = this.state.new ? this.newProtocolInput.value : this.state.listName;
      if (this.state.listName === null) { return }

      this.popupHeading.classList.add('hidden');
      this.popupForm.classList.add('hidden');
      this.loading.classList.remove('hidden');
      this.popupHeading.innerText = this.popupHeading.getAttribute('data-success-text');

      this.state.products.push({
        du: window.location.href.split('?')[0],
        empi: parseInt(this.saveTrigger.getAttribute('data-product-id'), 10),
        epi: this.closest('.product').querySelector('input[name="id"]').value,
        qty: 1,
        cprops: {
          type: 'retail'
        }
      })

      const detail = {
        listName: this.state.listName,
        labelName: this.state.labelName,
        clientName: this.state.clientName ? this.state.clientName : this.clientSelect.value,
        allergyInformation: this.state.allergyInformation,
        emailAddress: this.state.emailAddress ? this.state.emailAddress : this.clientSelect.options[this.clientSelect.selectedIndex].getAttribute('data-email-address'),
        products: this.state.products
      }

      document.dispatchEvent(new CustomEvent('saveConfigurator', { detail }));
    }
  }

  window.customElements.define('save-protocol-popup', SaveProtocolPopup)
}

if (!window.customElements.get('line-item-main-product-price')) {
  class LineItemMainProductPrice extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.updatePrice();
    }

    updatePrice() {
      const wrapper = this.closest('[data-line-item-wrapper]');
      if (!wrapper) { return; }
      const price = wrapper.querySelector('[data-line-item-price]');
      price.innerText = this.innerText;
    }
  }

  window.customElements.define('line-item-main-product-price', LineItemMainProductPrice);
}

if (!window.customElements.get('main-cart')) {
  class MainCart extends HTMLElement {
    constructor() {
      super();
      this.submitButton = this.querySelector('button[type="submit"]');
      this.shipmentEmailInput = this.querySelector("#email-address-for-shipment-updates");
      this.shipmentError = this.querySelector(".shipment-input-error");
    }

    connectedCallback() {
      this.validateCartItems();
      this.submitButton.addEventListener('click', (event) => this.setAddress(event));

      this.shipmentEmailInput.addEventListener("input",this.debounce(()=>{
        this.updateShipmentEmail()
      },300).bind(this));

    }

    async setAddress(event) {
      event.preventDefault();
      const addresses = this.getAttribute('data-addresses') ? JSON.parse(this.getAttribute('data-addresses')) : [];

      if (addresses.length) {
        event.preventDefault();
        const cart = await this.getCart();
        const clientName = cart?.attributes['Client Name'];

        if (clientName) {
          const matchingAddress = addresses.find((address) => address.name === clientName);

          if (matchingAddress) {
            const addAddressQuery = await storefront.fetch(await cartDeliveryAddressesAdd(matchingAddress.id, cart.token));
            await storefront.fetch(await cartDeliveryAddressesUpdate(matchingAddress.name, cart.token, addAddressQuery?.cartDeliveryAddressesAdd?.cart?.delivery?.addresses));
          }
        }
      }

      window.location.href = '/checkout';
    }

    async getCart() {
      const requestOptions = {
        method: 'GET',
        redirect: 'follow',
        headers: {
          'Content-Type': 'application/json',
        }
      };

      return await fetch('/cart.json', requestOptions)
        .then((response) => {
          return response.json()
        })
        .then((result) => {
          return result
        })
        .catch((error) => {
          return error
        });
    }

    async validateCartItems() {
      const cartData = await fetch('/cart.json', {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'xmlhttprequest'
        }
      })
      .then(response => response.json())
      .then(response => { return response; })
      .catch((error) => {console.log(error)});

      const childProducts = cartData?.items?.filter((item) => item.properties._type && item.properties._type !== 'main');

      if (!childProducts.length) { return; }

      const itemsToUpdate = [];

      childProducts.forEach((childProduct) => {
        const matchingParent = cartData.items.find((item) => item.properties._type === 'main' && item.properties._protocol === childProduct.properties._protocol);

        if (matchingParent) {
          const targetQuantity = (matchingParent.quantity * parseInt(childProduct.properties._quantity));

          if (childProduct.quantity !== targetQuantity) {
            itemsToUpdate.push({
              key: childProduct.key,
              quantity: targetQuantity
            })
          }
        } else if (!matchingParent) {
          itemsToUpdate.push({
            key: childProduct.key,
            quantity: 0
          });
        }
      });

      if (!itemsToUpdate.length) { return; }

      let updates = Object.fromEntries(itemsToUpdate?.map((item) => {
        return [
          item.key, item.quantity
        ]
      }));

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest'
        },
        body: JSON.stringify({ updates })
      })
      .then(response => response.json())
      .then((res) => {
        if (res.status === 422) {
          alert(res.message);
        } else {
          window.location.reload();
        }
       })
      .catch((error) => {console.log(error)});
    }

    updateShipmentEmail(){
      this.shipmentError.classList.add("hidden");
      const shipmentEmail = this.shipmentEmailInput.value;
      const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if(shipmentEmail != "")
      {
        if(pattern.test(shipmentEmail))
        {
          this.updateShipmentRequest(shipmentEmail);
        }
        else{
          this.shipmentError.classList.remove("hidden");
        }
      }
      else
      {
        this.updateShipmentRequest('');
      }
      
    }

    updateShipmentRequest(email){

      let updates = {
        attributes: {
          'Shipment Updates': email
        }
      };

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  window.customElements.define('main-cart', MainCart);
}

/**
 * @desc Shopify storefront request
 */
const storefront = new class StoreFront {
  constructor () {
    this.STOREFRONT_API_TOKEN = window.storefront?.apiToken
    this.STOREFRONT_API_VERSION = window.storefront?.apiVersion
    this.STORE = window.storefront?.store
    this.invalidCredentials = false

    if (
      typeof this.STORE !== 'undefined' &&
      typeof this.STOREFRONT_API_TOKEN !== 'undefined' &&
      typeof this.STOREFRONT_API_VERSION !== 'undefined' &&
      this.STOREFRONT_API_TOKEN !== null
    ) { return }

    console.warn('STOREFRONT_API_TOKEN, STOREFRONT_API_VERSION, or STORE is not set.')
    this.invalidCredentials = true
  }

  async fetch (graphqlData) {
    if (this.invalidCredentials) { return null }

    const fetchHeaders = new Headers() // eslint-disable-line
    fetchHeaders.append('x-shopify-storefront-access-token', this.STOREFRONT_API_TOKEN)
    fetchHeaders.append('Content-Type', 'application/json')

    const requestOptions = {
      method: 'POST',
      headers: fetchHeaders,
      body: graphqlData
    }

    const response = await fetch(`https://${this.STORE}/api/${this.STOREFRONT_API_VERSION}/graphql.json`, requestOptions)
      .then(response => response.json())

    if (response.errors) {
      console.error(response.errors)
      return null
    }

    return response.data
  }
}()

/**
 * @desc Add a delivery address to the cart
 * @param {String} id -> ID of the address that should be active
 * @param {String} cartToken -> Cart token
 */
const cartDeliveryAddressesAdd = async (id, cartToken) => {
  const graphQlVariables = {
    "id": `gid://shopify/Cart/${cartToken}`,
    "addresses": [
      {
        "selected": true,
        "address": {
          "copyFromCustomerAddressId": `gid://shopify/MailingAddress/${id}?model_name=CustomerAddress`
        }
      }
    ]
  }

  const graphQlQuery = `
    mutation CartDeliveryAddressesAdd($id: ID!, $addresses: [CartSelectableAddressInput!]!) {
      cartDeliveryAddressesAdd(cartId: $id, addresses: $addresses) {
        userErrors {
          message
          code
          field
        }
        warnings {
          message
          code
          target
        }
        cart {
          id
          delivery {
            addresses {
              id
              selected
              oneTimeUse
              address {
                ... on CartDeliveryAddress {
                  firstName
                  lastName
                  company
                  address1
                  address2
                  city
                  provinceCode
                  zip
                  countryCode
                }
              }
            }
          }
        }
      }
    }
  `

  return JSON.stringify({
    query: graphQlQuery,
    variables: graphQlVariables
  })
}

/**
 * @desc Update the selected delivery address
 * @param {String} matchingAddressName -> Name of the address that should be active
 * @param {String} cartToken -> Cart token
 * @param {Array} cartAddresses -> Available addresses on the cart
 */
const cartDeliveryAddressesUpdate = async (matchingAddressName, cartToken, cartAddresses) => {
  const graphQlVariables = {
    "id": `gid://shopify/Cart/${cartToken}`,
    "addresses": cartAddresses.map((address) => {
      const clientName = `${address.address.firstName} ${address.address.lastName}`
      return {
        "id": address.id,
        "selected": clientName === matchingAddressName
      }
    })
  }

  const graphQlQuery = `
    mutation CartDeliveryAddressesUpdate($id: ID!, $addresses: [CartSelectableAddressUpdateInput!]!) {
      cartDeliveryAddressesUpdate(cartId: $id, addresses: $addresses) {
        userErrors {
          message
          code
          field
        }
        warnings {
          message
          code
          target
        }
        cart {
          id
          delivery {
            addresses {
              id
              selected
              oneTimeUse
              address {
                ... on CartDeliveryAddress {
                  firstName
                  lastName
                  company
                  address1
                  address2
                  city
                  provinceCode
                  zip
                  countryCode
                }
              }
            }
          }
        }
      }
    }
  `

  return JSON.stringify({
    query: graphQlQuery,
    variables: graphQlVariables
  })
}

if (!window.customElements.get('address-form-email-company')) {
  class AddressFormEmailCompany extends HTMLElement {
    constructor() {
      super();
      this.fakeEmailInput = this.querySelector('[data-fake-email-input]');
      this.fakeCompanyInput = this.querySelector('[data-fake-company-input]');
      this.companyInput = this.querySelector('[data-company-input]');
    }

    connectedCallback() {
      this.fakeEmailInput.addEventListener('keyup', () => this.updateCompanyInput());
      this.fakeCompanyInput.addEventListener('keyup', () => this.updateCompanyInput());
    }

    /**
     * Update real company input with the combined values of the fake inputs
     */
    updateCompanyInput() {
      this.companyInput.value = `${this.fakeCompanyInput.value}|${this.fakeEmailInput.value}`;
    }
  }

  window.customElements.define('address-form-email-company', AddressFormEmailCompany);
}

/**
 * Check inventory levels and return an error popup if variant is unavailable.
 * @param {Array} products - Array of objects used to validate variants. Ex. [{handle: 'handle', variantId: 123456789}, {handle: 'handle2', variantId: 12345678}]
 * @param {String} editButtonLink - Link for the edit button
 */
async function checkInventoryLevels(products, editButtonLink) {
  const inventoryLevels = [];
  const inventoryLevelsPopupTrigger = document.querySelector('[data-inventory-levels-popup-trigger]');
  const inventoryLevelsPopupContent = document.querySelector('[data-inventory-levels-popup-content]');
  const inventoryLevelsPopupEditButton = document.querySelector('[data-inventory-levels-popup-edit]');

  for (let index = 0; index < products.length; index++) {
    const product = products[index];

    const productData = await fetch(`/products/${product.handle}.js`, {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      }
    })
    .then(response => response.json())
    .then(response => { return response; })
    .catch((error) => {console.log(error)});

    const matchingVariant = productData?.variants.find((variant) => variant.id === parseInt(product.variantId));

    inventoryLevels.push({
      name: product.title,
      available: matchingVariant ? matchingVariant.available : false
    })
  }

  const soldoutItems = inventoryLevels.filter((item) => item.available === false);

  if (!soldoutItems.length) { return; }

  const soldoutItemNames = soldoutItems.map((item) => {
    return item.name
  })

  if (inventoryLevelsPopupTrigger) {
    inventoryLevelsPopupTrigger.click();
  }

  if (inventoryLevelsPopupContent) {
    inventoryLevelsPopupContent.innerText = `${soldoutItemNames.join(' and ')} ${soldoutItemNames.length === 1 ? 'is' : 'are'} no longer available.`
  }

  if (inventoryLevelsPopupEditButton) {
    inventoryLevelsPopupEditButton.setAttribute('href', editButtonLink);
    inventoryLevelsPopupEditButton.classList.toggle('hidden', !editButtonLink);
  }

  return soldoutItems;
}

if (!window.customElements.get('address-form')) {
  class AddressForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
    }

    connectedCallback() {
      this.form.addEventListener('submit', (event) => this.formSubmission(event));
    }

    /**
     * Toggle the loading / disabled state of the form's submit button.
     * The theme's <button is="custom-button"> only clears its spinner on a
     * `pageshow` event, which never fires here because we submit via fetch,
     * so we have to manage it ourselves.
     * @param {Boolean} isLoading
     */
    setLoading(isLoading) {
      const submitButton = this.form.querySelector('[type="submit"]');
      if (!submitButton) { return; }

      submitButton.toggleAttribute('disabled', isLoading);

      if (isLoading) {
        submitButton.setAttribute('aria-busy', 'true');
      } else {
        submitButton.removeAttribute('aria-busy');
      }
    }

    /**
     * Show an inline error message inside the form.
     * @param {String} message
     */
    showError(message) {
      let errorElement = this.form.querySelector('[data-address-form-error]');

      if (!errorElement) {
        errorElement = document.createElement('p');
        errorElement.className = 'text-error text-sm text-start';
        errorElement.setAttribute('data-address-form-error', '');
        errorElement.setAttribute('role', 'alert');
        this.form.prepend(errorElement);
      }

      errorElement.textContent = message;
      errorElement.hidden = false;
    }

    clearError() {
      const errorElement = this.form.querySelector('[data-address-form-error]');
      if (errorElement) { errorElement.hidden = true; }
    }

    /**
     * Stop form redirect and handle address creation submission
     * @param {Event} event - Form submission event
     */
    async formSubmission(event) {
      if (window.location.href.indexOf('/products/') === -1) { return; }

      event.preventDefault();
      this.clearError();
      this.setLoading(true);

      const formData = new FormData(this.form);

      try {
        const url = this.form.getAttribute('action');
        const response = await fetch(url, {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
          headers: { 'Accept': 'text/html' }
        });

        // Session expired / not signed in -> Shopify bounces to the login page
        if (response.redirected && /\/account\/login/.test(response.url)) {
          throw new Error('Your session has expired. Please refresh the page, sign in again, and retry.');
        }

        const responseText = await response.text();

        if (!response.ok) {
          throw new Error(`We couldn't save this client (error ${response.status}). Please try again.`);
        }

        // On a validation failure Shopify re-renders the form (HTTP 200) with error markup
        const parsedResponse = new DOMParser().parseFromString(responseText, 'text/html');
        const serverError = parsedResponse.querySelector('.form__message--error, .errors li, .form-status--error');

        if (serverError && serverError.textContent.trim()) {
          throw new Error(serverError.textContent.trim());
        }

        this.addClientToSelect(formData);
        this.setLoading(false);

        const drawer = this.closest('x-drawer') || document.getElementById('customer-address-new');

        if (drawer && typeof drawer.hide === 'function') {
          // Reset the form only once the drawer has finished hiding, so the
          // user never sees a flash of an emptied form
          drawer.addEventListener('dialog:after-hide', () => this.form.reset(), { once: true });
          drawer.hide();
        } else {
          this.form.reset();
        }

      } catch (error) {
        console.error(error);
        this.setLoading(false);
        this.showError(error.message || 'Something went wrong. Please try again.');
      }
    }

    /**
     * Add the newly created client to the client-name picker and select it.
     *
     * Handles both markups this element is used in:
     *   - configurator: a <searchable-select> custom element
     *   - product page: a <client-information> element wrapping <div class="searchable-select">
     * In both cases the visible list is `.select-option` nodes inside `[data-options]`,
     * plus a hidden native <select> that we keep in sync.
     * @param {FormData} formData
     */
    addClientToSelect(formData) {
      const nativeSelect = document.querySelector('[data-configurator-client-name]') || document.querySelector('[data-client-information-name]');
      if (!nativeSelect) { return; }

      const firstName = (formData.get('address[first_name]') || '').trim();
      const lastName = (formData.get('address[last_name]') || '').trim();
      const clientValue = `${firstName} ${lastName}`.trim();
      if (!clientValue) { return; }

      const email = (formData.get('address[company]') || '').split('|')[1] || '';
      const label = email ? `${clientValue} (${email})` : clientValue;

      // 1. Hidden native <select>
      if (!Array.from(nativeSelect.options).some((opt) => opt.value === clientValue)) {
        const nativeOption = document.createElement('option');
        nativeOption.value = clientValue;
        nativeOption.textContent = label;
        nativeOption.setAttribute('data-email-address', email);
        nativeSelect.appendChild(nativeOption);
      }

      // 2. Visible searchable list
      const container = nativeSelect.closest('.form-control');
      const optionsWrapper = container?.querySelector('[data-options]');
      // Element that manages the visible list and exposes changeSelectBox()
      const widget = container?.closest('client-information') || container?.querySelector('searchable-select');

      if (optionsWrapper) {
        let selectOption = optionsWrapper.querySelector(`.select-option[data-value="${CSS.escape(clientValue)}"]`);

        if (!selectOption) {
          selectOption = document.createElement('div');
          selectOption.className = 'select-option';
          selectOption.setAttribute('data-value', clientValue);
          selectOption.setAttribute('data-email-address', email);
          selectOption.setAttribute('data-search-value', `${clientValue} ${email}`.trim());
          selectOption.textContent = label;
          // Wire future clicks the same way the theme wires its own options
          if (widget && typeof widget.changeSelectBox === 'function') {
            selectOption.addEventListener('click', () => widget.changeSelectBox(selectOption));
          }
          optionsWrapper.appendChild(selectOption);
        }

        // Reflect the selection in the visible UI without opening the dropdown
        optionsWrapper.querySelectorAll('.select-option').forEach((opt) => opt.classList.remove('selected'));
        selectOption.classList.add('selected');

        const trigger = container.querySelector('[data-trigger]');
        if (trigger) { trigger.textContent = label; }

        container.querySelector('[data-dropdown]')?.classList.add('hidden');

        // The product page also mirrors the chosen value into a hidden input
        const searchInput = container.querySelector('#client-name-search');
        if (searchInput) { searchInput.value = clientValue; }
      }

      // 3. Select it in the native <select> and notify listeners
      //    (configurator state, or <client-information> property inputs + ATC button)
      nativeSelect.value = clientValue;
      nativeSelect.dispatchEvent(new Event('change'));
    }
  }

  window.customElements.define('address-form', AddressForm);
}

if (!window.customElements.get('order-history-back-links')) {
  class OrderHistoryBackLinks extends HTMLElement {
    constructor() {
      super();
      this.accountLink = this.querySelector('[data-account-link]');
      this.clientDirectoryLink = this.querySelector('[data-client-directory-link]');
    }

    connectedCallback() {
      this.updateLinks();
    }

    updateLinks() {
      if (window.location.href.indexOf('?client-directory') >= 0) {
        this.accountLink.classList.add('hidden');
        this.clientDirectoryLink.classList.remove('hidden');
      } else {
        this.accountLink.classList.remove('hidden');
        this.clientDirectoryLink.classList.add('hidden');
      }
    }
  }

  window.customElements.define('order-history-back-links', OrderHistoryBackLinks);
}

const storeRedirectSelector = document.querySelector(".store-redirect-selector");
const storeRedirectActive = document.querySelector(".active-store");
const storeRedirectDropdown = document.querySelector(".store-redirect-dropdown");

storeRedirectSelector?.addEventListener("click", toggleSelector);

function toggleSelector(){
  const isToggle = storeRedirectDropdown.classList.toggle("hidden");
  if(isToggle)
  {
    storeRedirectActive.classList.remove("active");
  }
  else
  {
    storeRedirectActive.classList.add("active");
  }
}

const storeRedirectSelectorMobile = document.querySelector(".store-redirect-selector.mobile");
const storeRedirectActiveMobile = document.querySelector(".active-store.mobile");
const storeRedirectDropdownMobile = document.querySelector(
  ".new-header-store-redirect.mobile .store-redirect-dropdown"
);

storeRedirectSelectorMobile?.addEventListener("click", toggleSelectorMobile);

function toggleSelectorMobile(e) {
  e.preventDefault();

  if (!storeRedirectDropdownMobile) return;

  const isHidden = storeRedirectDropdownMobile.classList.toggle("hidden");

  if (storeRedirectActiveMobile) {
    storeRedirectActiveMobile.classList.toggle("active", !isHidden);
  }
}

if (!window.customElements.get('custom-search')) {
  class CustomSearch extends HTMLElement {
    constructor(){
      super();
      this.searchBtn = this.querySelector(".custom-search-icon");
      this.searchBar = this.querySelector(".custom-search-bar");
      this.closeBtn = this.querySelector(".custom-search-close");
      this.searchInput = this.querySelector("#blog-search-input");
      this.clearBtn = this.querySelector(".custom-search-clear");
      this.resultsContainer = document.getElementById("blog-results");
      this.loader = this.querySelector(".custom-search-loader");
      this.newLayout = this.getAttribute("data-new-layout");
    }

    connectedCallback(){
      this.searchBtn.addEventListener("click",()=>this.toggleSearchBar());
      this.closeBtn.addEventListener("click", ()=>this.toggleSearchBar());

      this.searchInput.addEventListener("input",this.debounce(()=>{
        this.search()
      },300).bind(this));

      this.clearBtn.addEventListener("click",()=>this.clearSearch());
    }

    toggleSearchBar(){
      const isShow = this.searchBar.classList.toggle("hidden");
      (!isShow)?this.searchInput.focus():"";
      document.querySelector(".blog-banner").classList.toggle("search-active");
    }

    search(){
      // console.log("search value is "+ this.searchInput.value);
      const q = this.searchInput.value.toLowerCase().trim();
      const handle = this.searchBar.getAttribute("data-handle");

      // Empty search = clear results
      if (q == '') {
        if(this.newLayout == "true")
        {
          this.resultsContainer.querySelector(".blog-result-body").innerHTML = "";
        }
        else{
          this.resultsContainer.innerHTML = "";
        }
        
        document.querySelector(".blog-posts").classList.remove("hidden");
        document.querySelector(".pagination").classList.remove("hidden");
      //  console.log("empty");
        return;
      }

      this.loader.classList.remove("hidden");

      fetch(`${window.location.pathname}?view=article-search`)
      .then(res => res.text())
      .then(data=>{
        const parser = new DOMParser()

        // Parse the text
        const result = parser.parseFromString(data, "text/html");
        let article = result.querySelector("#blog-articles-json");
        let jsonData =  JSON.parse(article.textContent);

        //console.log(jsonData);

        const filtered = jsonData.articles.filter(a =>
          a.title.toLowerCase().includes(q) ||
          a.content.toLowerCase().includes(q)
        );

        //console.log(filtered);

        if(filtered.length > 0)
        {
          this.renderPostHtml(filtered);
        }
        else
        {
          if(this.newLayout == "true")
          {
            this.resultsContainer.querySelector(".blog-result-body").innerHTML = "<tr class='blog-posts-row' row-span='3'><td>No posts found.</td></tr>";
          }
          else{
            this.resultsContainer.innerHTML = "<p>No posts found.</p>";   
          }
          
        }

        this.loader.classList.add("hidden");
        this.resultsContainer.classList.remove("hidden");
        document.querySelector(".blog-posts").classList.add("hidden");
        document.querySelector(".pagination").classList.add("hidden");

      });

    }

    renderPostHtml(results){
      if(this.newLayout == "true")
      {
        this.resultsContainer.querySelector(".blog-result-body").innerHTML = results.map(a=>`
            <tr class="blog-posts-row">
              <td class="">
                <a href="${a.url}">
                  <div class="blog-post">
                    <div class="blog-post-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text w-5 h-5 text-[#659891]"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg>
                    </div>
                    <div>
                      <div class="blog-post-title">${a.title}</div>
                      <div class="blog-post-description">${a.content}</div>
                    </div>
                  </div>
                </a>
              </td>
              <td>
              <div class="blog-post-btn">
                <a href="${a.url}"> Open</a>
              </div>
              </td>
            </tr>
          `).join("");
      }
      else
      {
        this.resultsContainer.innerHTML = results.map(a => `
          <blog-post-card class="blog-post-card snap-center group">
            <a href="${a.url}" class="blog-post-card__figure rounded1">
              <img src="${a.image}" alt="${a.title}" class="w-full h-full object-cover zoom-image">
            </a>
            <div class="blog-post-card__info">
              <div class="v-stack gap-4 sm:gap-5">
                <div class="v-stack gap-3 sm:gap-4">
                  <p class="h3">
                  <a href="${a.url}">
                    ${a.title}
                  </a>
                  </p>
                  <p>${a.content}</p>
                </div>
                <p style="${(a.download_link !='')?"":"display:none;"}">
                  <a href="${a.download_link}" target="_blank" title="${a.title}" class="link">
                    View &amp; Download
                  </a>
                </p>
                <div class="blog-post-card--tag">
                    ${a.tags.map(tag=>`<span>${tag}</span>`).join("")}
                </div>
              </div>
            </div>
          </blog-post-card>
        `).join("");
      }
      
    }

    clearSearch(){
      this.searchInput.value = "";
      this.search();
    }

    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }
  window.customElements.define('custom-search', CustomSearch);
}

function generateProtocolSummaryNew(target){
  const selector = target.closest("[data-saved-protocol]");
  const mainItem = selector.querySelector("[data-product-type='main']")
  const lable = selector.querySelector("[data-saved-protocol-line-property-key='Label Name']").innerHTML;
  const title = mainItem.querySelector("h4").innerHTML;
  const allergy = selector.querySelector("[data-saved-protocol-cart-attribute-key='Allergy Information']").innerHTML;
  const variant_selector = mainItem.querySelectorAll(".saved-protocol-list-item__variant li");
  const addon_selector = selector.querySelectorAll("[data-saved-protocols-category='addon'] li");
  const flavour_selector = selector.querySelectorAll("[data-saved-protocols-category='flavour'] li");
  const binder_selector = selector.querySelectorAll("[data-saved-protocols-category='binder'] li");
  const retail_selector = selector.querySelectorAll("[data-saved-protocols-category='retail'] li");
  const sku = mainItem.getAttribute("data-sku");

  const ingredient_list = selector.querySelector(".ingredients-dropdown-list .metafield-rich_text_field ul").innerHTML;

  let variant_title = "";
  let addonList = '';
  let additionalItemList = '';
  
  variant_selector.forEach((opt,index)=>{
    if(index == 0)
    {
      variant_title += opt.querySelector(".saved-protocol-list-item__content span").innerHTML;
    }
    else
    {
      variant_title += " / "+opt.querySelector(".saved-protocol-list-item__content span").innerHTML;
    }
  });

  addon_selector.forEach((addon)=>{
    const addonItem = addon.querySelector(".saved-protocol-list-item__product-title span:nth-child(2)")?.innerHTML;
    if(addonItem != undefined)
    {
      addonList += `<li class="addon-item">${addonItem}</li>`;
    }
  });

  flavour_selector.forEach((flavour)=>{
    const flavourItem = flavour.querySelector(".saved-protocol-list-item__product-title span:nth-child(2)")?.innerHTML;
    if(flavourItem != undefined)
    {
      additionalItemList += `<li class="addon-item">${flavourItem}</li>`;
    }
  });

  binder_selector.forEach((binder)=>{
    const binderItem = binder.querySelector(".saved-protocol-list-item__product-title span:nth-child(2)")?.innerHTML;
    if(binderItem != undefined)
    {
      additionalItemList += `<li class="addon-item">${binderItem}</li>`;
    }
  });

  retail_selector.forEach((retail)=>{
    const retailItem = retail.querySelector(".saved-protocol-list-item__product-title span:nth-child(2)")?.innerHTML;
    if(retailItem != undefined)
    {
      additionalItemList += `<li class="addon-item">${retailItem}</li>`;
    }
  });

  const protocolSummaryBody = `
      <div class="wrapper">
        <div class="header">
          <div class="shop-title">
            <p class="to-uppercase">
              VYKON CUSTOMS
            </p>
          </div>
        </div>
        <div class="hr"></div>
        <div class="order-container-header">
          <div class="order-container-header-sku">
            <p class="subtitle-bold to-uppercase">SKU</p>
          </div>
          <div class="order-container-header-left-content">
            <p class="subtitle-bold to-uppercase">Items</p>
          </div>
          <div class="order-container-header-right-content">
            <p class="subtitle-bold to-uppercase">Quantity</p>
          </div>
        </div>

      <div>

      <div class="flex-line-item">
        <div class="flex-line-item-sku">
          <p>
            ${sku}
          </p>
        </div>

        <div class="flex-line-item-description">
          <p>
            <p class="line-item-description-line">
              <strong>
                ${title}
              </strong>
            </p>
              <span class="line-item-description-line">
                ${variant_title}
              </span>
          </p>
            <p>
              ${lable}
            </p>
            <br>

            <p>
              ${allergy}
            </p>
            <br>

            ${(ingredient_list != '')?
            `<div>
              <p>
                View Base Ingredients :
              </p>
              <div>
                <ul class="list-disc">
                  ${ingredient_list}
                </ul>
              </div>
            </div>
            <br>`:""}

            ${(addonList != '')?
              `
              <div>
                <p>
                  Addons:
                </p>

                <ul class="list-disc">
                  ${addonList}
                </ul>
              </div>
            `:""}

            ${(additionalItemList != "")?`
              <div>
                <p>
                  Additional Products:
                </p>

                <ul class="list-disc">
                  ${additionalItemList}
                </ul>
              </div>
              `:""}
        </div>
        <div class="flex-line-item-quantity">
          <p class="text-align-right">
            1 of 1
          </p>
        </div>
      </div>
      </div>
        <div class="hr"></div>
        <div class="footer">
          <p>
            <small>
              Custom blends are available exclusively for dispensing by certified healthcare professionals and are provided without any express or implied warranty. These custom formulations have not been evaluated by the U.S. Food and Drug Administration (FDA) or Health Canada. Our products are not intended to diagnose, treat, cure, or prevent any disease. All sales of Vykon customized products are final and are not eligible for refund or exchange.
            </small>
          </p>
        </div>
      </div>
  `;

  generatePrint(protocolSummaryBody);

}

function generatePrint(body){
  const iframe = document.createElement('iframe');

  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';

  document.body.appendChild(iframe);

  const iframeDoc = iframe.contentWindow.document;
  iframeDoc.open();
  iframeDoc.write(`
      <html>
      <head>
          <title>Print</title>
          <style type="text/css">
            body {
              font-size: 12px;
            }

            * {
              box-sizing: border-box;
            }

            .wrapper {
              width: 831px;
              margin: auto;
              padding: 4em;
              font-family: "Noto Sans", sans-serif;
              font-weight: 250;
            }

            .header {
              width: 100%;
              display: -webkit-box;
              display: -webkit-flex;
              display: flex;
              flex-direction: row;
              align-items: top;
            }

            .header p {
              margin: 0;
            }

            .shop-title {
              -webkit-box-flex: 6;
              -webkit-flex: 6;
              flex: 6;
              font-size: 1.9em;
              margin-bottom: 1.9em
            }

            .order-title {
              -webkit-box-flex: 4;
              -webkit-flex: 4;
              flex: 4;
            }

            .customer-addresses {
              width: 100%;
              display: inline-block;
              margin: 2em 0;
            }

            .address-detail {
              margin: 0.7em 0 0;
              line-height: 1.5;
            }

            .subtitle-bold {
              font-weight: bold;
              margin: 0;
              font-size: 0.85em;
            }

            .to-uppercase {
              text-transform: uppercase;
            }

            .text-align-right {
              text-align: right;
            }

            .shipping-address {
              float: left;
              min-width: 18em;
              max-width: 50%;
            }

            .billing-address {
              padding-left: 20em;
              min-width: 18em;
            }

            .order-container {
              padding: 0 0.7em;
            }

            .order-container-header {
              display: inline-block;
              width: 100%;
              margin-top: 1.4em;
            }

            .order-container-header-left-content {
              float: left;
            }

            .order-container-header-right-content {
              float: right;
            }

            .flex-line-item {
              display: -webkit-box;
              display: -webkit-flex;
              display: flex;
              flex-direction: row;
              align-items: start;
              margin: 1.4em 0;
              page-break-inside: avoid;
            }

            .flex-line-item-img {
              margin-right: 1.4em;
              min-width: {{ desired_image_size }}px;
            }

            .flex-line-item-description {
              -webkit-box-flex: 7;
              -webkit-flex: 7;
              flex: 7;
            }

            .line-item-description-line {
              display: block;
            }

            .flex-line-item-description p {
              margin: 0;
              line-height: 1;
            }

            .flex-line-item-quantity {
              -webkit-box-flex: 3;
              -webkit-flex: 3;
              flex: 3;
            }

            .subdued-separator {
              height: 0.07em;
              border: none;
              color: lightgray;
              background-color: lightgray;
              margin: 0;
            }

            .missing-line-items-text {
              margin: 1.4em 0;
              padding: 0 0.7em;
            }

            .notes {
              margin-top: 2em;
            }

            .notes p {
              margin-bottom: 0;
            }

            .notes .notes-details {
              margin-top: 0.7em;
            }

            .footer {
              margin-top: 2em;
              text-align: center;
              line-height: 1.5;
            }

            .footer p {
              margin: 0;
              margin-bottom: 1.4em;
            }

            @media print{
              .hr {
                height: 2px;
                width:100%;
                border: 1px solid black;
                color: black;
                background-color: black;
                margin: 0;
              }
            }

            .aspect-ratio {
              position: relative;
              display: block;
              background: #fafbfc;
              padding: 0;
            }

            .aspect-ratio::before {
              z-index: 1;
              content: "";
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              border: 1px solid rgba(195,207,216,0.3);
            }

            .aspect-ratio--square {
              width: 100%;
              padding-bottom: 100%;
            }

            .aspect-ratio__content {
              position: absolute;
              max-width: 100%;
              max-height: 100%;
              display: block;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              margin: auto;
            }

            .order-container-header-sku {
              float: left;
              width: 15%;
            }

            .flex-line-item-sku {
              -webkit-box-flex: 2;
              -webkit-flex: 2;
              flex: 2;
              padding-right: 1em;
            }
          </style>
      </head>
      <body>
        ${body}
      </body>
      </html>
  `);

  iframeDoc.close();
  iframe.contentWindow.print();
  document.body.removeChild(iframe);
}

// New header

 const header_dropdown = document.querySelector(".new-header-dropdown");
 const header_content = document.querySelector(".new-header-dropdown-content");
 const header_opener = document.querySelector(".new-header-opener");
 const account_nav = document.querySelector("#shopify-section-account-nav");
 const account_nav_close = document.querySelector(".account-nav-close");
 const account_nav_overlay = document.querySelector(".account-nav-overlay");

//not nav
 const new_nav = document.querySelector("#new-header-nav-main");
  const new_nav_close = document.querySelector(".new-nav-close");
 const new_nav_overlay = document.querySelector(".new-nav-overlay");
 header_dropdown?.addEventListener("click",()=>{
  header_dropdown.classList.toggle("active");
  header_content.classList.toggle("hidden");
 });

 header_opener?.addEventListener("click",()=>{
  account_nav?.classList.toggle("active");
 });

 account_nav_close?.addEventListener("click",()=>{
  account_nav?.classList.toggle("active");
 });

 account_nav_overlay?.addEventListener("click",()=>{
  account_nav?.classList.toggle("active");
 });

//not nav
  header_opener?.addEventListener("click",()=>{
  new_nav?.classList.toggle("active");
 });

 new_nav_close?.addEventListener("click",()=>{
  new_nav?.classList.toggle("active");
 });

 new_nav_overlay?.addEventListener("click",()=>{
  new_nav?.classList.toggle("active");
 });


// New header

// Get Started Page

function openVideoPopup(url) {

  let embedUrl = getEmbedUrl(url);

  if(url.indexOf("player.vimeo.com") != -1 || url.indexOf("youtube.com/embed") != -1)
  {
    embedUrl = url
  }

  if (!embedUrl) {
    console.error("Unsupported video url");
    return;
  }

  // Remove existing popup
  document
    .querySelector(".video-popup")
    ?.remove();

  const popup = document.createElement("div");

  popup.className = "video-popup";

  popup.innerHTML = `
    <div class="video-popup__overlay"></div>

    <div class="video-popup__content">

      <button
        class="video-popup__close"
        aria-label="Close"
      >
        ✕
      </button>

      <iframe
        src="${embedUrl}"
        allow="autoplay; fullscreen"
        allowfullscreen
        frameborder="0"
      ></iframe>

    </div>
  `;

  document.body.append(popup);

  const close = () => {
    popup.remove();

    document.removeEventListener(
      "keydown",
      escHandler
    );
  };

  const escHandler = (e) => {
    if (e.key === "Escape") {
      close();
    }
  };

  popup
    .querySelector(".video-popup__close")
    .addEventListener("click", close);

  popup
    .querySelector(".video-popup__overlay")
    .addEventListener("click", close);

  document.addEventListener(
    "keydown",
    escHandler
  );
}


/**
 * Convert video URL to embed URL
 */
function getEmbedUrl(url) {

  // Youtube

  const youtubeRegex =
    /(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?/]+)/;

  const ytMatch =
    url.match(youtubeRegex);

  if (ytMatch) {

    return `https://www.youtube.com/embed/${ytMatch[1]}?autoplay=1`;
  }


  // Vimeo

  const vimeoRegex =
    /vimeo\.com\/(\d+)/;

  const vimeoMatch =
    url.match(vimeoRegex);

  if (vimeoMatch) {

    return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1`;
  }

  return null;
}

// Get Started Page

// blog page tags

const track = document.querySelector(".blog-filter-list ul");
const leftArrow = document.querySelector(".blog-list-left");
const rightArrow = document.querySelector(".blog-list-right");

if(track)
{

  const slideWidth = track.querySelector("li")?.offsetWidth || 0;

  leftArrow.addEventListener("click",()=>{
    scroll("left");
  });

  rightArrow.addEventListener("click",()=>{
    scroll("right");
  });


  track.addEventListener("scroll", () => updateArrows());

  updateArrows();

  function scroll(direction){
    const scrollAmount = slideWidth + 16; // slide + gap
    const distance = direction === "left" ? - scrollAmount : scrollAmount;

    track.scrollBy({
      left: distance,
      behavior: "smooth"
    });

  }

  function updateArrows() {
    const maxScrollLeft =
      track.scrollWidth - track.clientWidth;

    if (leftArrow) {
      leftArrow.disabled = track.scrollLeft <= 0;
    }

    if (rightArrow) {
      rightArrow.disabled =
        track.scrollLeft >= maxScrollLeft - 1;
    }
  }
  
}


// blog page tags